import { createContext } from 'react';

const PhoneLogContext = createContext();
PhoneLogContext.displayName = 'PhoneLogContext';

export default PhoneLogContext;
